
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchDistricts } from './fetch-districts';
import { useMemo } from 'react';
import { useRouter } from 'next/router';
import sortBy from 'lodash/sortBy';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  initialData?: P | null
};

/**
 * Action type.
 */

export const actionType = ({ locale }): string => {
  return `${locale}-districts`;
};

/**
 * `useDistricts` hook.
 */

function useDistricts<P>(options?: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const result = useQuery([actionType(variables), variables], () => {
    return fetchDistricts(variables);
  }, {
    initialData: options?.initialData
  });

  const data = useMemo(() => sortBy(result?.data, ['name']), [result]);

  return {
    ...result,
    data
  };
}

/**
 * Export `useDistricts` hook.
 */

export default useDistricts;
